<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow" ref="dir-block">
      <template v-slot:title>
        <div class="d-flex ma-1 no-wrap">
          <v-select outlined :items="dirList" item-text="text" item-value="value" v-model="type" label="Справочник" hide-details dense class="mt-1" />
          <portal-target name="v-dir-title" />
        </div>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="$refs.table.updateData()">
          <btn-title icon="fas fa-sync-alt">Обновить</btn-title>
        </v-btn>
        <v-btn v-if="!dirCurrent.readonly && canEdit" color="primary" @click="createNew()" title="Создать элемент">
          <btn-title icon="far fa-plus-square">Создать</btn-title>
        </v-btn>
      </template>
      <portal to="v-main">
        <s-document-dialogs-detail-edit
          v-if="showEditDialog && dirCurrent.type == 'config'"
          v-model="showEditDialog"
          :id="idEdit"
          :dataTable="tableData"
          :readonly="false"
          :m="dirM"
          @save="saveConfig($event)"
        />
        <dir-dialog v-else-if="showEditDialog" v-model="showEditDialog" :id="idEdit" :api="dirCurrent.api" :dir="dirCurrent" />
      </portal>
      <a-table-f-data2
        v-if="dirCurrent.type == 'data' || dirCurrent.type == 'config' || false"
        ref="table"
        :dataTable="tableDataC"
        :model="autoModel || model"
        :useQuery="false"
        :defaults="{
          sort: {},
        }"
        @click="onClickRow($event)"
      />
      <component v-else-if="dirM.listName" ref="table" :is="dirM.listName" :dirCurrent="dirCurrent" @clickRow="onClickRow($event)" />

      <a-table-f-api v-else ref="table" :api="dirCurrent.api" :model="model" :useQuery="false" :defaults="defaults" @click="onClickRow($event)" />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow && !personalView" :idShow="idItemShow" :dirCurrent="dirCurrent" :m="dirM" @close="itemShowClose($event)" />
    <component v-if="idItemShow && personalView" :is="personalView" :idShow="idItemShow" :dirCurrent="dirCurrent" :m="dirM" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, genModel } from "@/components/mixings";

export default {
  mixins: [getAccess, genModel],
  components: {
    dirDialog: () => import("./dialogs/dirDialog"),
    ViewItem: () => import("./views/dirView"),
    GoodsType: () => import("./views/dirGoodsTypeList"),
  },
  data() {
    return {
      personalView: null,
      idEdit: 0,
      idItemShow: 0,
      showEditDialog: false,
      title: "",
      m: this.$store.getters["config/get"].models.dirs,
      dirs: this.$store.getters["config/get"].models.dirs.list,
      url: "",
      type: null,
      types: [1],
      autoModel: null,
      tableData: [],
      configData: null,
      dd: [
        { name: "value", title: "value", type: "string", size: 8 },
        { name: "canSchedule", title: "Расписание", type: "select", options: "boolean", size: 4 },
        { name: "text", title: "Наименование", type: "string" },
        { name: "hidden", title: "Скрыто", type: "select", options: "boolean", size: 6 },
        { name: "priority", title: "Приоритет", type: "number", size: 6 },
        { name: "color", title: "Цвет", type: "string", size: 4 },
        { name: "color", title: "Цвет", type: "color", size: 2 },
        { name: "icon", title: "Icon", type: "string", size: 6 },
        { name: "users", title: "Пользователи", type: "selectuser", chips: true, returnObject: false, size: 12 },
      ],
    };
  },
  created() {
    this.$root.title = "Справочники";
    if (this.$attrs?.dir) {
      this.type = this.dirList.find((el) => el.name == this.$attrs.dir)?.value || null;
    }
    // this.getDirCurrent();
  },
  computed: {
    defaults() {
      return { sort: { key: "id", order: "ASC" }, filters: this.dirCurrent.filters, paramName: this.dirCurrent.name };
    },
    dirM() {
      const name = this.dirCurrent?.name || null;
      let m;
      if (this.dirCurrent?.model && typeof this.dirCurrent?.model == "string" && this.$store.getters["config/get"].models?.[this.dirCurrent.model]) {
        m = Object.assign({}, this.$store.getters["config/get"].models[this.dirCurrent.model]);
      } else {
        m = Object.assign({}, this.m[name]);
      }
      return m;
    },
    dirList() {
      let list = this.dirs.filter((el) => {
        return this.getAccess("dirs." + el.name + ".view");
      });
      if (!true) {
        let parents = [];
        let listP = [];
        list
          .filter((l) => !!l.parent)
          .forEach((l) => {
            if (parents.includes(l.parent)) {
            } else {
              parents.push(l.parent);
              listP.push(this.dirs.find((d) => d.value == l.parent));
            }
          });
        list = [...listP, ...list];
      }
      return list;
    },
    canEdit() {
      return this.getAccess("dirs." + this.dirCurrent.name + ".create") || (this.dirCurrent?.role || []).includes(this.$root.profile.role);
    },
    dirCurrent() {
      if (!this.type) this.type = this.dirList[0]?.value || null;
      return this.dirList.find((el) => el.value == this.type);
    },
    model() {
      const name = this.dirCurrent?.name || null;

      if (!name) return {};
      let model;
      let m;
      if (this.dirCurrent?.model && typeof this.dirCurrent?.model == "string" && this.$store.getters["config/get"].models?.[this.dirCurrent.model]) {
        m = Object.assign({}, this.$store.getters["config/get"].models[this.dirCurrent.model]);
      } else {
        m = Object.assign({}, this.m[name]);
      }
      model = m.list;
      model.forEach((el) => {
        if (el?.sourceList) {
          el.options = m[el.sourceList];
        }
      });

      return model;
    },
    tableDataC() {
      this.getData();
      return this.tableData;
    },
  },
  watch: {
    dirCurrent(t) {
      if (t && this.$attrs?.dir != t.name) this.$router.push({ query: { dir: t.name } });
      this.configData = null;
      if (t && ["config", "data"].includes(t.type)) {
        this.getData();
      }
    },
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    async getData() {
      this.tableData = [];
      const name = this.dirCurrent.name;
      let tmp;
      let model = this.model;
      let data = [];

      const dir = this.dirCurrent;
      if (dir.type == "config") {
        const api = "/config/edit";
        let res = await this.$axios.get(api, { params: { filters: { key: dir.key } } });
        console.log({ res });
        tmp = res?.data?.data?.[0]?.data || [];
        this.tableData = [...tmp];
        this.configData = res?.data?.data?.[0];
        //this.autoModel = m.list;
        //return;
      } else if (dir?.dir) {
        // const dir = (this.$dir.get(name) || []).map((item) => ({ ...item }));
        //
        tmp = (this.$dir.get(name) || []).map((item) => ({ ...item }));
      } else {
        const path = this.dirCurrent.path.split(".");
        for (let i = 0; i < path.length; i++) {
          const el = path[i];
          if (i === 0) {
            tmp = JSON.parse(JSON.stringify(this.$store.getters["config/get"] || {}));
          }
          tmp = JSON.parse(JSON.stringify(tmp?.[el] || {}));
        }
      }
      let obj = tmp;
      if (true) {
        for (const key in obj) {
          if (Object.hasOwnProperty.call(obj, key)) {
            const el = obj[key];
            const row = { id: typeof key == "string" ? key : +key };
            if (!model.find((el) => el.name == "id")) {
              model.push({ name: "id", title: "id", type: "string" });
            }
            for (const k in el) {
              row[k] = el[k];
              if (!model.find((el) => el.name == k)) {
                model.push({ name: k, title: k, type: "variant" });
              }
            }
            data.push(row);
          }
        }
      }

      this.autoModel = model;
      let res = data.sort((a, b) => {
        return isNaN(a.id) ? (a.id > b.id) - (b.id > a.id) : parseFloat(a.id) > parseFloat(b.id);
      });
      this.tableData = [...res];
      return res;
    },
    getDirCurrent() {
      //  this.dirCurrent = this.dirList.filter((el) => el.value == this.type);
    },
    onClickRow(d) {
      //if (!this.canEdit ) return
      console.log("click", this.dirCurrent.type, this.dirCurrent.view, this.dirM.viewName, this.dirM);
      if (this.dirCurrent.type == "config") {
        this.showEditDialogFun(d.row.id);
      } else if (!this.dirCurrent.type) {
        if (this.dirCurrent.view) this.idItemShow = d.row.id;
        else if (this.dirM.viewName) this.loadComponent(d, this.dirM);
        else this.showEditDialogFun(d.row.id);
      }
    },
    async saveConfig(e) {
      this.tableData = e;
      if (this.configData && this.configData.id) {
        const api = "/config/edit";
        const data = { id: this.configData.id, data: e };
        let response = await this.$axios.post(api, data);
        let status = response.data.status == "ok";
        if (status) {
          this.$root.$emit("show-info", {
            text: "Данные сохранены",
          });
        } else {
          this.$root.$emit("show-info", {
            type: "error",
            text: "Ошибка изменения данных",
          });
        }
      }
    },
    createNew() {
      this.showEditDialogFun(null);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
    itemShowClose() {
      this.loading = true;
      this.$root.title = "Справочники";
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
    async loadComponent(d, m) {
      const path = "@/views/admin/views";
      this.personalView = null;
      try {
        const name = m.viewName; //"dirLeadGroupView"
        console.log("name", name, path);
        let component = this.$options.components[name] || this.$root.$options.components[name];

        if (!component) {
          const requireComponent = require.context("@/views/admin/views", true, /\.vue$/);

          if (requireComponent.keys().includes(`./${name}.vue`)) {
            const componentConfig = requireComponent(`./${name}.vue`);
            component = componentConfig.default || componentConfig;

            // Регистрируем глобально (не обязательно, но удобно)
            this.$root.$options.components[name] = component;
            console.log("Зарегистрирован новый компонент:", name);
          } else {
            console.error("Компонент не найден:", name);
            console.log("Доступные файлы:", requireComponent.keys());
            throw new Error(`Компонент ${name}.vue не найден`);
          }
        } else {
          console.log("Компонент уже зарегистрирован:", name);
        }

        this.personalView = component;
        this.idItemShow = d.row.id;
      } catch (e) {
        console.error("Ошибка загрузки компонента:", path, e);
        this.personalView = null;
      }
    },
  },
};
</script>
